module.exports = __webpack_public_path__ + "static/media/maintitle01.81b22198.png";